var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEditAlt(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.1334 5.26634C13.4 4.99967 13.4 4.59967 13.1334 4.33301L10.3334 1.53301C10.0667 1.26634 9.66671 1.26634 9.40004 1.53301L7.53337 3.39967L11.3334 7.19967L13.1334 5.26634ZM3.33337 11.9997H6.13337C6.33337 11.9997 6.46671 11.933 6.60004 11.7997L10.2667 8.13301L6.53337 4.33301L2.86671 7.99967C2.73337 8.13301 2.66671 8.33301 2.66671 8.53301V11.333C2.66671 11.733 2.93337 11.9997 3.33337 11.9997ZM14 13.333H2.00004C1.60004 13.333 1.33337 13.5997 1.33337 13.9997C1.33337 14.3997 1.60004 14.6663 2.00004 14.6663H14C14.4 14.6663 14.6667 14.3997 14.6667 13.9997C14.6667 13.5997 14.4 13.333 14 13.333Z",
    fill: "#38369C"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEditAlt);
export default __webpack_public_path__ + "static/media/edit-alt.3c6f7a2955bc4ded888f749d18f36fcc.svg";
export { ForwardRef as ReactComponent };